import { render, staticRenderFns } from "./PercentageProgress.vue?vue&type=template&id=aa6e844e"
import script from "./PercentageProgress.vue?vue&type=script&lang=ts"
export * from "./PercentageProgress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports